<template>
  <fieldset class="table-cta a-bordered-fieldset" v-if="persistedTokens.length > 0">
    <legend class="a-bordered-fieldset__legend">
      <template v-if="numStandaloneOrders < 1"
        >Mine bordbestillinger</template
      >
      <template v-else
        >Mine borde</template
      >
    </legend>
    <HUILoadingView class="table-cta__loading" v-if="!items || items.length < 1" />
    <transition-group v-else class="table-cta__list" name="table-cta__item-" tag="ul">
      <li class="table-cta__item" v-for="item in items" :key="'table-cta__item-' + item.orderToken">
        <div class="table-cta__booking">
          <div class="table-cta__content">
            <p>
              <span class="table-cta__restaurant-name">Halifax {{ item.restaurantName }}</span>
              <span class="table-cta__restaurant-time">{{ item.time }}</span>
              <span v-if="item.closed" class="table-cta__mute">Afsluttet</span>
              <span v-else-if="item.seated" class="table-cta__mute">Ankommet</span>
              <a
                v-else-if="item.bookingToken"
                class="table-cta__mute"
                href
                @click.prevent="handleCancelBookingClick(item.bookingToken)"
                >Afbestil</a
              >
              <a class="table-cta__mute" @click.prevent="handleRemoveClick(item.orderToken)" href
                >Skjul</a
              >
            </p>
          </div>
          <!-- <HUIButton
            v-if="item.closed"
            class="table-cta__button"
            theme="green"
            @click="handleButtonClick(item)"
          >{{ gotoTableReceiptButtonText }}</HUIButton>
          <HUIButton
            v-else-if="item.seated"
            class="table-cta__button"
            theme="green"
            @click="handleButtonClick(item)"
          >{{ gotoTableButtonText }}</HUIButton>
          <HUIButton
            v-else-if="item.bookingToken"
            class="table-cta__button"
            theme="green"
            @click="handleButtonClick(item)"
          >{{ gotoPreorderButtonText }}</HUIButton> -->
        </div>
      </li>
    </transition-group>
  </fieldset>
</template>

<script>
import { mapState } from 'vuex'
import { HUIButton, HUILoadingView } from '@/halifax-ui'
import { getDateString, getDateRelativity } from '@/utils/dateHelpers'
import routes from '@/router/routes'
import { OrderStatus } from '@/store/order'

export default {
  components: { HUIButton, HUILoadingView },
  props: {
    gotoPreorderButtonText: {
      type: String,
      default: 'Bestil mad'
    },
    gotoTableButtonText: {
      type: String,
      default: 'Gå til bord'
    },
    gotoTableReceiptButtonText: {
      type: String,
      default: 'Vis kvittering'
    }
  },
  computed: {
    ...mapState({
      persistedTokens: 'persisted_tokens'
    }),
    ...mapState('booking', {
      bookings: 'bookings'
    }),
    ...mapState('order', {
      orders: 'orders'
    }),
    /**
     * Returns the number of standalone orders (i.e. orders without a booking),
     * meaning a table that was accessed through "go to table" or via the link.
     */
    numStandaloneOrders() {
      return this.persistedTokens.reduce((acc, entry) => {
        if (entry.order_token && !entry.booking_token) {
          acc += 1
        }
        return acc
      }, 0)
    },
    allOrderTokens() {
      return this.persistedTokens.map(entry => entry.order_token)
    },
    items() {
      return Object.keys(this.orders).map(orderToken => {
        const booking = this.bookings.find(b => b.order_token === orderToken)
        const order = this.orders[orderToken]

        // 2018/08/10 14:30:00.00000 -> 2018-08-10 14:30:00 for Safari
        const time = new Date(
          (booking ? booking.starts_at : order.scheduled_for).replace(/-/g, '/').substring(0, 19)
        )
        const { isToday, isTomorrow, isYesterday } = getDateRelativity(time)
        const hideMonthAndDay = isToday || isTomorrow || isYesterday
        const closed = order.status === OrderStatus.CLOSED
        // Assume that the table is seated if order is open and table_description can be parsed as an int (bordnummer)
        const seated = !isNaN(parseInt(order.table_description, 10))
        return {
          orderToken,
          bookingToken: booking ? booking.token : null,
          restaurantName: order.restaurant_name,
          time: this.formatTime(time, hideMonthAndDay),
          seated,
          closed
        }
      })
    }
  },
  created() {
    this.$store.dispatch('FETCH_PERSISTED_TOKENS')
  },
  methods: {
    formatTime(time, hideMonthAndDay) {
      const format = {
        weekday: hideMonthAndDay ? null : undefined,
        day: hideMonthAndDay ? null : '2-digit',
        month: hideMonthAndDay ? null : '2-digit'
      }
      return getDateString(new Date(time), format)
    },
    handleButtonClick(item) {
      if (item.closed) {
        this.$router.push({
          name: routes.TABLE_RECEIPT,
          params: { orderToken: item.orderToken }
        })
      } else if (item.seated) {
        this.$router.push({
          name: routes.TABLE_INTRO,
          params: { orderToken: item.orderToken }
        })
      } else {
        this.$router.push({
          name: routes.BOOKING_PREORDER_INTRO,
          params: { bookingToken: item.bookingToken }
        })
      }
    },
    handleCancelBookingClick(bookingToken) {
      this.$router.push({
        name: routes.CANCEL_BOOKING,
        params: { bookingToken }
      })
    },
    async handleRemoveClick(orderToken) {
      try {
        const didConfirm = await this.$store.dispatch('dialog/CONFIRM', {
          props: {
            heading: 'Er du sikker?',
            body: 'Hvis du fortsætter kan du ikke tilgå ordren længere.'
          }
        })
        if (didConfirm) {
          this.$store.dispatch('FORGET_TOKENS', orderToken)
          this.$store.commit('order/REMOVE', orderToken)
        }
      } catch (error) {
        throw error
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/halifax-ui/src/scss/framework';
@import '~@/scss/variables';

.table-cta {
  $module: '.table-cta';
  font-weight: 700;
  max-width: $max-width-narrow-block;
  margin-left: auto;
  margin-right: auto;

  .window--framed & {
    display: none;
  }
  &__loading {
    height: 60px;
  }
  &__item {
    overflow: hidden;
    max-height: 110px;

    &:first-child {
      margin-top: -20px;
    }
    &:last-child {
      margin-bottom: -20px;
    }

    &--leave-active,
    &--enter-active {
      transition: max-height 400ms;
    }
    &--enter,
    &--leave-to {
      max-height: 0px;
    }
  }
  &__booking {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    padding: 20px 0;

    #{$module}__item + #{$module}__item & {
      border-top: 1px solid rgba($text-color, 0.2);
    }
  }
  &__content {
    flex: 1 0;
  }
  &__restaurant-time,
  &__restaurant-name {
    display: block;

    &::first-letter {
      text-transform: capitalize;
    }
  }
  &__mute {
    display: inline-block;
    color: $halifax-green;
    line-height: 1.3;
    margin-top: 2px;
    color: rgba($text-color, 0.3);

    &[href] {
      text-decoration: none;
      border-bottom: 1px solid currentColor;
    }

    + #{$module}__mute {
      margin-left: 7px;
    }
  }
  &__button {
    font-size: 1.4rem;
    flex-shrink: 0;
    font-weight: 700;
    padding-left: 0;
    padding-right: 0;
    width: 104px;
  }
}
</style>
